import React__default from 'react';
import { Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Form, Field, CheckboxView, FormGroup, FirstName, LastName, Email } from '@grandvisionhq/forms';
import { Icon } from '@grandvisionhq/icons';
import { pushNewsletterEvent } from '../../data-layer/newsletter.js';

const NewsletterForm = ({ labels , showCancelButton , variant , authEmail , isSubscribeWithEmailChecked , isLoading , showSubscribeWithEmailError , onSubscribeWithEmailChange , onSubmit , onModalClose ,  })=>{
    const onHandleNewsletterEvent = ()=>{
        pushNewsletterEvent({
            interactionType: 'field_click'
        });
    };
    return /*#__PURE__*/ React__default.createElement(Form, {
        name: `newsletter-${variant}`,
        className: "newsletter__form",
        initialFormState: authEmail ? {
            email: {
                name: 'email',
                value: authEmail,
                isTouched: true,
                isValid: true
            },
            subscribeWithEmail: {
                name: 'subscribeWithEmail',
                value: 'checked',
                isTouched: true,
                isValid: true
            }
        } : undefined,
        showErrorsOnInvalidSubmit: false,
        onSubmit: onSubmit,
        onBlur: onHandleNewsletterEvent
    }, authEmail ? /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(Field, {
        name: "subscribeWithEmail",
        error: "" // error should not be possible on this field, this is a required prop
        ,
        onChange: onSubscribeWithEmailChange
    }, /*#__PURE__*/ React__default.createElement(CheckboxView, {
        id: "subscribeWithEmail",
        error: showSubscribeWithEmailError,
        label: labels.subscribeWithEmail,
        checked: isSubscribeWithEmailChecked,
        value: isSubscribeWithEmailChecked,
        onChange: ()=>null
    })), showSubscribeWithEmailError && /*#__PURE__*/ React__default.createElement("div", {
        className: "newsletter__error-container"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "information-circle",
        height: 16,
        width: 16
    }), /*#__PURE__*/ React__default.createElement(Text, {
        className: "newsletter__error-text",
        variant: "body"
    }, labels.subscribeWithEmailError))) : /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(FormGroup, {
        columns: 2
    }, /*#__PURE__*/ React__default.createElement(FirstName, {
        required: false,
        label: labels.firstName,
        hideAsteriskSign: true
    }), /*#__PURE__*/ React__default.createElement(LastName, {
        required: false,
        label: labels.lastName,
        hideAsteriskSign: true
    })), /*#__PURE__*/ React__default.createElement(Email, {
        required: true,
        label: labels.emailAddress,
        errorMessage: labels.emailAddressErrorMessage
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "newsletter__controls"
    }, /*#__PURE__*/ React__default.createElement(Button, {
        className: "newsletter__button",
        isLoading: isLoading,
        caption: labels.signUp,
        type: "submit"
    }), showCancelButton ? /*#__PURE__*/ React__default.createElement(Button, {
        className: "newsletter__button",
        variant: "outline",
        caption: labels.closeModal,
        onClick: onModalClose
    }) : null));
};
var NewsletterForm$1 = NewsletterForm;

export { NewsletterForm$1 as default };
//# sourceMappingURL=NewsletterForm.js.map
